import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Button } from 'reactstrap';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { DisabledPage } from './pages/disabled/DisabledPage';
import { LoginPage } from './pages/session/LoginPage';
import { SubscribedPage } from './pages/static/SubscribedPage';
import { Footer } from './partials/Footer';
import { Header } from './partials/Header';
import { IndexPage } from './pages/index/IndexPage';
import { SubscriptionsPage } from './pages/subscriptions/SubscriptionsPage';
import { ProfilePage } from './pages/profile/ProfilePage';
import {HelpPage} from "./pages/static/HelpPage";
import {EmailConfirmedPage} from "./pages/static/EmailConfirmedPage";

export interface ProfileLayoutProps {
}

@observer export class ProfileLayout extends Component<ProfileLayoutProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        if (!this.userStore.isReady) {
            return null;
        }

        return <div className={'profile-layout'}>
            <Header />

            <Switch>
                <Route path={`/login`} component={LoginPage} />
                <Route path={`/profile`} component={ProfilePage} />
                <Route path={`/disabled`} component={DisabledPage} />
                {/*<Route path={`/subscribed/:id?`} component={SubscribedPage} />*/}
                <Route path={`/subscription-success`} component={SubscribedPage} />
                <Route path={`/email-success`} component={EmailConfirmedPage} />
                <Route path={`/subscriptions/:id?`} component={SubscriptionsPage} />
                <Route path={`/help`} component={HelpPage} />
                <Route path={`/`} component={IndexPage} />
            </Switch>

            <Footer />
        </div>
    }

}
